<div class="wrap">
  <div class="wrap__container">
    <div class="container">
      <div class="container__background"></div>
      <div class="container__content">
        <div class="content">
          <app-image-title
            class="content__title"
            type="story"
          >BÜKIのストーリー</app-image-title>
          <p class="content__text">あるところに、絵本に魅せられた一人の少女がいました。少女は絵本の不思議なお話、素敵な絵大好きでした。とくに少女が夢中になったのは、自分がその絵本の主人公となったお話を想像すること。</p>
          <p class="content__text">少女は想像のなかでは、何者にもなることができ、なんでもできました。ドラゴンに乗って雲の上へ飛んだり、動物たちと秘密のお話をしたり、スーパーヒーローになって世界を救ったり。</p>
          <p class="content__text">しかしいつの日か、少女は「主人公になれるのは、特別な子だけで、私は普通の子だからなれない」と考えるようになりました。豊かで自由だった想像の世界に、蓋をしたのです。</p>
          <p class="content__text">時は流れ、少女は母になりました。子を見て思い出したのは、少女だった頃に感じた ”自分ではない誰かに憧れる” 寂しい気持ち。「この子には、自分は特別な存在で、何にでもなれると信じてほしい」そう思いました。</p>
          <p class="content__text">そして魔法（イラストやテクノロジー）を使える仲間が加わり、<b>誰でも物語の主人公になれる絵本</b>ができました。どんな子も、自身の可能性を信じて欲しいという願いを込めて。</p>
          <p class="content__text">絵本の主人公になりたかった少女の想像は、現実になりました。次は、あの子の不思議で素敵な想像の世界が、叶うかもしれません。</p>
        </div>
      </div>
      <div class="container__character"></div>
    </div>
  </div>
</div>
